import {combineReducers} from 'redux';

import reducer from './reducer';

const appReducer = combineReducers({app: reducer});

export default appReducer;
